import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';

interface IProps {
  maxWidth?: DialogProps['maxWidth'];
  onCancel: () => void;
  onSubmit: (tempHtml: string) => void;
  visible: boolean;
  editImageLinkDestination: string;
}

export default function ModalEditImageLink(props: IProps) {
  const {
    editImageLinkDestination,
    visible,
    onCancel,
    maxWidth,
    onSubmit,
  } = props;
  const { t } = useTranslation();
  const [
    tempEditImageLinkDestination,
    setTempEditImageLinkDestination,
  ] = useState<any>(editImageLinkDestination);
  return (
    <Dialog
      open={visible}
      onClose={onCancel}
      maxWidth={maxWidth}
      fullWidth
      disableEnforceFocus
    >
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              value={tempEditImageLinkDestination || ''}
              placeholder={t('destination')}
              onChange={(e) => {
                setTempEditImageLinkDestination(e.target.value);
              }}
            />
          </Grid>
          <Grid container item justifyContent="flex-end">
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={() => {
                onSubmit(tempEditImageLinkDestination);
              }}
            >
              {t('save')}
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
